import {DISCUSSION_API, ADD_DISCUSSION_DISLIKE_ERROR} from '../../../constants';

export const removeDiscussionLike = async ({
    discussionId,
    userDiscussionLikeId
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${DISCUSSION_API}/${discussionId}/likes/${userDiscussionLikeId}`, {
            method: 'DELETE',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            })
        });
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw ADD_DISCUSSION_DISLIKE_ERROR;
    }
};